import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import VeeValidate from 'vee-validate'
import PortalVue from 'portal-vue'

/**
* Import other dependencies.
*/
import 'mixins'
import 'filters'
import 'utils/notify'
import 'utils/font-awesome'
import 'utils/components'
import 'utils/validation'
import 'bootstrap'
import './directives'

/**
 * Import theme SCSS.
 */
import 'assets/scss/theme.scss'

Vue.use(PortalVue)

Vue.use(VeeValidate, {
  events: 'blur',
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
